module.exports = __webpack_public_path__ + "img/captcha.b485c2e3.png";